const getTimestampObject = () => {
  return {
    seconds: Math.floor(Date.now() / 1000),
    nanoseconds: 0,
  };
};

export default getTimestampObject;
